<form class="list-search-container {{bottomSpacing ? 'mb-3' : ''}} {{roundedCorners ? '' : 'no-radius'}}" autocomplete="off">
    <div class="list-search-form">
        <input type="text"
               [(ngModel)]="searchVar"
               (input)="onSearchVarUpdate.emit(searchVar)"
               name="name"
               placeholder="{{ placeholderText | translate }}"
               class="list-search-input">
    </div>
    <button *ngIf="!disableAddition"
            type="submit"
            class="btn btn-xs btn-outline-primary mr-2"
            (click)="callAddEvent(searchVar)">{{ 'New' | translate }}</button>
</form>